// extracted by mini-css-extract-plugin
export default {"btnPrev":"Slider_btnPrev__5yuL8","btnNext":"Slider_btnNext__GsICz","carSlider":"Slider_carSlider__7J8Fa"};